import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './shell/AppShell';
import { BillingRoute } from './routes/BillingRoute';
import { CatalogRoute } from './routes/CatalogRoute';
import { LegacySharedRedirect } from './routes/LegacySharedRedirect';
import { LibraryRoute } from './routes/LibraryRoute';
import { InviteRoute } from './routes/InviteRoute';
import { RequireAuth } from './routes/RequireAuth';
import { RootLayout } from './routes/RootLayout';
import { RouteErrorFallback } from './routes/RouteErrorFallback';

/** Префикс `/app` — из vite.config.ts через BASE_URL (NFR-1). */
export const routerBasename = import.meta.env.BASE_URL.replace(/\/$/, '');

export const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      errorElement: <RouteErrorFallback />,
      children: [
        // Публичные адреса вне auth-гейта (AUTH-1, CNV-24, CNV-32).
        { path: 'shared/:token', lazy: () => import('./routes/SharedCanvasRoute') },
        { path: 'boards/shared/:token', element: <LegacySharedRedirect /> },
        {
          element: <RequireAuth />,
          children: [
            {
              element: <AppShell />,
              children: [
                { index: true, element: <CatalogRoute /> },
                { path: 'saved', element: <LibraryRoute tab="saved" /> },
                { path: 'canvases', element: <LibraryRoute tab="canvases" /> },
                // Канвас — отдельный чанк с ErrorBoundary (NFR-4).
                { path: 'canvases/:id', lazy: () => import('./routes/CanvasRoute') },
                { path: 'billing', element: <BillingRoute /> },
                { path: 'invites/:token', element: <InviteRoute /> },
                { path: '*', element: <Navigate to="/" replace /> },
              ],
            },
          ],
        },
      ],
    },
  ],
  { basename: routerBasename },
);
